export function removeAuthToken(){
    localStorage.removeItem("authToken");
}

export function removeLoggedUser(){
    localStorage.removeItem("loggedUser");
}

export function removeMembership(){
    localStorage.removeItem("membership");
}

export function removeLicense(){
    localStorage.removeItem("license");
}

export function removeInstitution(){
    localStorage.removeItem("institution");
}